var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInspection09(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_22194",
    "data-name": "\\uADF8\\uB8F9 22194",
    transform: "translate(8700 -5419)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1582",
    "data-name": "\\uD0C0\\uC6D0 1582",
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    transform: "translate(-8700 5419)",
    fill: "#605200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10373",
    "data-name": "\\uD328\\uC2A4 10373",
    d: "M4.829,4.08A3.66,3.66,0,0,1,2.258,5,3.873,3.873,0,0,1-.788,3.757,4.974,4.974,0,0,1-1.9.333,4.932,4.932,0,0,1-.636-3.292,3.758,3.758,0,0,1,2.154-4.4,3.773,3.773,0,0,1,5.468-2.914,3.218,3.218,0,0,1,6.09-1.239H4.213a2.534,2.534,0,0,0-.469-.975A1.908,1.908,0,0,0,2.227-2.8a1.881,1.881,0,0,0-1.614.825A3.968,3.968,0,0,0,.022.364,3.483,3.483,0,0,0,.647,2.627a1.973,1.973,0,0,0,1.587.752,1.815,1.815,0,0,0,1.5-.646,2.805,2.805,0,0,0,.475-1.042H6.072A4.038,4.038,0,0,1,4.829,4.08Z",
    transform: "translate(-8692.597 5428.2)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspection09);
export default __webpack_public_path__ + "static/media/inspection_09.84f09675f3c668dee7eed9fee36a944c.svg";
export { ForwardRef as ReactComponent };